import type { CSSProperties } from "react";

export function iframeStyle(
  border: boolean,
  override?: CSSProperties,
): CSSProperties {
  return {
    backgroundColor: "var(--color-gray-darker)",
    border: border ? "1px solid var(--color-gray-lighter)" : undefined,
    borderRadius: "var(--radius-2xl) var(--radius-2xl) var(--radius-2xl) 0",
    ...override,
  };
}
